import { namespace } from 'vuex-class';
import { IFieldState } from './field.types';

export const fieldNamespace = 'document/fields';
export const Fields = namespace(fieldNamespace);

export const state: IFieldState = {
  fields: [],
  loading: false,
  pageWidth: null,
  verifiedInitialFieldIds: [],
};

export enum EFieldAction {
  Load = 'load',
  LoadSuccess = 'loadSuccess',
  LoadFailed = 'loadFailed',
  UpdatePageWidth = 'updatePageWidth',
  UpdateValue = 'updateValue',
  UpdateValueFailed = 'updateValueFailed',
  AddVerifiedInitialId = 'addVerifiedInitialId',
}

export enum EFieldMutation {
  SetLoading = 'setLoading',
  SetFields = 'setFields',
  SetPageWidth = 'setPageWidth',
  UpdateField = 'updateField',
  SetVerifiedInitialFieldIds = 'setVerifiedInitialFieldIds',
}

export enum EFieldGetter {
  PositionedFields = 'positionedFields',
}
